import PropTypes from 'prop-types';
import { Tooltip } from '@material-ui/core';

import TranslationConstant from '@/common/constant/TranslationConstant';
import { trI18n } from '@/common/utils/trI18n';
import DataChangePleaseReloadModal from '@/component/common/modal/DataChangePleaseReloadModal';

import '@/component/multiLanguage/elements/DetailContentOnDemandControl.css';

const { ON_DEMAND_TRANSLATION_STATUS } = TranslationConstant;

HtmlOnDemandToggle.propTypes = {
    toggleId: PropTypes.string.isRequired,
    onDemand: PropTypes.shape({
        isVisible: PropTypes.bool,
        isOn: PropTypes.bool,
        status: PropTypes.string,
        toggle: PropTypes.func,
        isReloadModalOpen: PropTypes.bool,
        setIsReloadModalOpen: PropTypes.func
    }).isRequired,
    className: PropTypes.string
};

/**
 * 「翻訳版」toggle of an HTML field (MLT-001-F3, data-tr-ondmd). One toggle for the whole field
 * (every tab of the app at once). Same look as the content-detail on-demand toggle; shown only
 * when the field was served with the translation runtime and has on-demand markers.
 */
export default function HtmlOnDemandToggle({ toggleId, onDemand, className = '' }) {
    if (!onDemand?.isVisible) return null;

    const isLoading = onDemand.status === ON_DEMAND_TRANSLATION_STATUS.LOADING;

    return (
        <div className={`detail-ondemand-translation ${className}`.trim()} data-cy="html-ondemand-translation">
            <span className="detail-ondemand-translation-label">
                {trI18n('CM-ONDEMAND-TRANSLATION-TOGGLE-LABEL')}
            </span>

            <div className="switch-check">
                <input
                    name="htmlOnDemandTranslation"
                    id={toggleId}
                    type="checkbox"
                    checked={onDemand.isOn}
                    disabled={isLoading}
                    onChange={onDemand.toggle}
                    data-cy="html-ondemand-translation-toggle"
                />
                <label htmlFor={toggleId}></label>
            </div>

            {isLoading && (
                <Tooltip title={trI18n('CM-ONDEMAND-TRANSLATION-LOADING-TOOLTIP')} arrow placement="right-end">
                    <img
                        className="option-icon icon-loading"
                        src={`/assets/image/icon-loading.svg`}
                        alt="icon-loading"
                        data-cy="html-ondemand-translation-loading"
                    />
                </Tooltip>
            )}

            <DataChangePleaseReloadModal
                isOpen={Boolean(onDemand.isReloadModalOpen)}
                setIsOpen={onDemand.setIsReloadModalOpen}
            />
        </div>
    );
}
